var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuild(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_3084)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6331 3.04364C10.7332 2.15108 9.26434 2.15391 8.37552 3.04269L6.20971 5.2085L9.99967 8.99843L13.7938 5.20433L11.6339 3.04448L11.6331 3.04364ZM14.7955 6.20606L11.0013 10.0002L14.7913 13.7901L16.9571 11.6243C17.8459 10.7355 17.8488 9.26649 16.9561 8.36666L16.9553 8.36593L14.7955 6.20606ZM17.9588 12.626C19.4031 11.1817 19.4006 8.81798 17.9607 7.36776L12.6338 2.04096L12.6321 2.03919C11.1818 0.599247 8.81805 0.596694 7.37379 2.04096L4.71035 4.7044L4.7071 4.70763L4.70387 4.71088L2.04878 7.36598L2.04699 7.36776C0.60706 8.81798 0.604506 11.1817 2.04878 12.626L4.64634 15.2236C4.66484 15.2476 4.68509 15.2707 4.7071 15.2927C4.7291 15.3147 4.7522 15.335 4.77621 15.3535L7.37379 17.9511L7.37557 17.9528C8.82579 19.3927 11.1896 19.3953 12.6338 17.9511L17.9588 12.626ZM13.7896 14.7918L9.99967 11.0019L6.21387 14.7877L8.37374 16.9475L8.37448 16.9482C9.27433 17.8409 10.7433 17.8382 11.6321 16.9493L13.7896 14.7918ZM5.21214 13.7859L8.9979 10.0002L5.20798 6.21024L3.05228 8.36593L3.05143 8.36679C2.15889 9.26666 2.16173 10.7355 3.05051 11.6243L5.21214 13.7859Z",
    fill: "#D37F2F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_3084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuild);
export default __webpack_public_path__ + "static/media/build.1a5fa65cf0e1145ba9eed6343dd01ce1.svg";
export { ForwardRef as ReactComponent };